import type { Adjustments, FilterOption } from './PriceSimulation.types';
import type { WorksheetFilters } from './PriceSimulationWorksheet.types';
import { seedAdjustments } from './seedAdjustments';
import { calculateWorksheet } from './worksheetCalculations';
import type { PackageWorksheet } from './worksheetDataTransformer';

export const findPackagesMatchingFilters = (
    worksheets: PackageWorksheet[],
    packageOptions: FilterOption[],
    adjustments: Adjustments,
    filters: WorksheetFilters
): FilterOption[] => {
    const matchingIds = new Set(calculateWorksheet(worksheets, seedAdjustments(adjustments, worksheets), filters).packages.map((pkg) => pkg.packageId));
    return packageOptions.filter((option) => matchingIds.has(String(option.id)));
};
